const SNAKE_CASE_REGEXP = /[A-Z]/g

export function snake_case(str: string, separator = '_'): string {
  return str.replace(SNAKE_CASE_REGEXP, (letter, pos) => {
    return (pos ? separator : '') + letter.toLowerCase()
  })
}
